// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__1qa_v","input3":"Counter_input3__1KC85","input4":"Counter_input4__cd6Fa","input5":"Counter_input5__2L_5w"};